export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_q03_b.baba5f74.png";